import { render, staticRenderFns } from "./TrainingCalendarReadOnly.vue?vue&type=template&id=aa3788e4&scoped=true&"
import script from "./TrainingCalendarReadOnly.vue?vue&type=script&lang=ts&"
export * from "./TrainingCalendarReadOnly.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingCalendarReadOnly.vue?vue&type=style&index=0&id=aa3788e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3788e4",
  null
  
)

export default component.exports